import { Divider } from "@mui/material";

const CustomDivider = () => {
  return <Divider style={{ backgroundColor: "#E4E4E4" }} />;
};

export default CustomDivider;
